import { ref } from "vue"

const listener = ref<{ open: () => void; close: () => void } | undefined>()

export function useMobileAppBanner() {
	return {
		setup: (openCallback: () => void, closeCallback: () => void): void => {
			listener.value = {
				open: openCallback,
				close: closeCallback
			}
		},
		open: (): void => {
			listener.value?.open()
		},
		close: (): void => {
			listener.value?.close()
		}
	}
}
